import { Handshake, Percent, Users } from 'lucide-react'
import { TFunction } from 'i18next'
import Active from './Active'
import Candidates from './Candidates'
import CommissionPolicies from '../CommissionPolicies'

interface AffiliateListTabsOptions {
    policyModalOpen: boolean
    setPolicyModalOpen: (open: boolean) => void
    canManagePolicies: boolean
}

export const tabs = (t: TFunction, options: AffiliateListTabsOptions) => [
    {
        label: t('confirmed'),
        value: 'confirmed',
        startIcon: <Handshake className="w-4 h-4" />,
        component: <Active />,
    },
    {
        label: t('pending_confirmation'),
        value: 'candidates',
        startIcon: <Users className="w-4 h-4" />,
        component: <Candidates />,
    },
    {
        label: t('commission_policies'),
        value: 'policies',
        startIcon: <Percent className="w-4 h-4" />,
        hidden: !options.canManagePolicies,
        component: (
            <CommissionPolicies
                embedded
                modalOpen={options.policyModalOpen}
                setModalOpen={options.setPolicyModalOpen}
            />
        ),
    },
]
